import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-bitcoin-icon',
  templateUrl: './shopping-bitcoin.component.html'
})
export class ShoppingBitcoinComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
